export default {"src":"/_next/static/media/geography.0a143fd2.svg","height":26,"width":22,"blurWidth":0,"blurHeight":0};